import React, { useState, useEffect } from "react";
import "./Slider.scss";
import { Range, getTrackBackground } from "react-range";

const STEP = 0.1;
const MIN = 0;
const mainClass = "slider";

const Slider = ({ rtl, title, max, values, handleChange }) => {
  useEffect(() => {
    if (values[1] > max) {
      const newValues = [...values];
      newValues[1] = max - 10;
      handleChange(newValues);
    }
  }, [max]);

  return (
    <div className={mainClass}>
      <div className={mainClass + "-title"}>{title}</div>
      <Range
        values={values}
        step={STEP}
        min={MIN}
        max={max}
        rtl={rtl}
        onChange={(values) => handleChange(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                background: getTrackBackground({
                  values,
                  colors: ["#ccc", "#447F3F", "#ccc"],
                  min: MIN,
                  max: max,
                  rtl,
                }),
                alignSelf: "center",
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ index, props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "20px",
              width: "20px",
              borderRadius: "3px",
              backgroundColor: "#447F3F",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 2px 6px #AAA",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: index > 0 ? "-28px" : "20px",
                color: "black",
                fontWeight: "bold",
                fontSize: "14px",
                fontFamily: "Spectral,serif",
                padding: "4px",
                borderRadius: "4px",
              }}
            >
              {Math.round(values[index])}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default Slider;
